
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { ActionButton } from 'office-ui-fabric-react/lib/Button';

import {
    IfComp,
    PanelSectionTitle
} from '../../core';

import DialogMeasureInfo from './DialogMeasureInfo';
import { getMainValue } from './measureUtils';

const MeasureItem = ({index, item}) => {

    const classNames = mergeStyleSets({
        root: {
            paddingLeft: 16,
            paddingTop: 2,
            paddingBottom: 2
        },
        index: {
            width: 20
        },
        type: {
            width: 40
        },
        value: {
            paddingLeft: 4,
        },
        detailIcon: {
            fontSize: '16px',
            height: '20px',
            width: '32px',
            cursor: 'pointer'
        }
    });

    const handleClick = () => {
        DialogMeasureInfo.show(item);
    }

    const mainValue = getMainValue(item.values);
    let valueText = null;

    if (mainValue) {
        valueText = `${mainValue.definition.title} ${mainValue.value.toFixed(2)} ${mainValue.definition.unit}`;
    } else {
        if (item.values.coords.length === 1) {
            let coord = item.values.coords[0];
            valueText = `Pozice ${coord.x.toFixed(0)}; ${coord.y.toFixed(0)}; ${coord.z.toFixed(0)}`;
        }
    }

    return (
        <IfComp cond={!!valueText}>
            <Stack horizontal className={classNames.root}>
                <div className={classNames.index}>{index + 1}.</div>
                <div className={classNames.type}>({item.type})</div>
                <Stack.Item grow className={classNames.value}>
                    <div>{valueText}</div>
                </Stack.Item>
                <ActionButton
                    title="Zobrazit detail měření"
                    onClick={handleClick}
                    iconProps={{iconName: 'Info'}}
                    className={classNames.detailIcon}
                />
            </Stack>
        </IfComp>
    );
}

const MeasureList = ({list}) => {

    const classNames = mergeStyleSets({
        root: {
        },
    });

    return (
        <IfComp cond={(list.length > 0)}>
            <Stack className={classNames.root}>
                <Stack.Item>
                    <PanelSectionTitle title="Seznam všech měření" />
                </Stack.Item>
                {list.map((item, index) => {
                    return (
                        <Stack.Item key={item.id}>
                            <MeasureItem index={index} item={item} />
                        </Stack.Item>
                    );
                })}
            </Stack>
        </IfComp>
    );
}

export default MeasureList;
